import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import CategoryTable from "components/incidentType/CategoryTable";
import Container from "components/layout/Container";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Category: React.FC = () => {
  const { t } = useTranslation("incidentTypeCategory");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle" component="h1">
            {t("title")}
          </HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <CategoryTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const CategoryAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(
      ModuleNames.incidentManagement,
      ModulePolicyTypes.incident
    );
  }, [hasModulePolicy]);
  return <>{hasRight ? <Category /> : <NotFound />}</>;
};
export default Category;
